"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var MistralFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M704 192.02v127.97H576v128.02H448V320H320V192.05H192.05v512H64v127.97h384.01V704.04H320V576.03h128.02v128.01h128.02V576.03H704v128.01H576.03v127.98H960V704.04H831.95V192.02z" } }] }, "name": "mistral", "theme": "filled" };
exports.default = MistralFilled;
